<template>
  <form class="default-form" @submit.prevent="validateForm()">
    <div class="form-group">
      <label>{{ _T('Full Name') }} <span class="error-class">*</span></label>
      <input
        required
        v-model="guest.name"
        type="text"
        class="form-control custom-input"
        :placeholder="_T('Full Name')"
        autocomplete="new-password"
      />
      <span class="validation-error  d-block pt-1" v-if="errors.name">
        {{ errors.name }}
      </span>
    </div>
    <div class="form-group">
      <!--      <label>{{ _T('Email') }} <span class="error-class">*</span></label>-->
      <input
        required
        v-model="guest.email"
        type="text"
        class="form-control custom-input"
        :placeholder="_T('Email')"
        autocomplete="new-password"
      />
      <span class="validation-error  d-block pt-1" v-if="errors.email">
        {{ errors.email }}
      </span>
    </div>
    <div class="form-group">
      <label>{{ _T('Phone Number') }} <span class="error-class">*</span></label>
      <phone-number-input
        @custom-input="payload => (guest.phone = payload)"
        v-model="guest.phone"
      />
      <span class="validation-error  d-block pt-1" v-if="errors.phone">
        {{ errors.phone }}
      </span>
    </div>
    <customer-address-form ref="customerAddressForm"></customer-address-form>
  </form>
</template>
<script>
import { validateEmail, validatePhoneNumber } from '@/utils/main_utils'
import { mapGetters } from 'vuex'
import { isObjectEmpty } from '../../../../utils/main_utils'
import PhoneNumberInput from '@/components/Elements/PhoneNumberInput.vue'

import CustomerAddressForm from '@/components/Modals/CustomerAddress/CreateAddressForm.vue'

export default {
  name: 'CheckoutAsGuestUser',
  data: () => ({
    errors: {},
  }),
  computed: {
    ...mapGetters(['_T']),
    guest: {
      get() {
        return this.$store.getters.guest_info
      },
      set(value) {
        this.$store.commit('SET_GUEST_INFO', value)
      },
    },
  },
  components: {
    CustomerAddressForm,
    PhoneNumberInput,
  },
  methods: {
    validateForm() {
      this.errors = {}
      if (
        !this.guest.name ||
        !this.guest.name.trim() ||
        this.guest.name.length < 3
      ) {
        this.errors.name = this._T(
          'Please provide full name with 3 or more characters'
        )
      }

      if (this.guest.email) {
        if (!validateEmail(this.guest.email)) {
          this.errors.email = this._T('Please provide correct email address')
        }
      }

      if (!validatePhoneNumber(this.guest.phone)) {
        this.errors.phone = this._T('Please provide correct phone number')
      }

      if (isObjectEmpty(this.errors)) {
        return this.$refs.customerAddressForm.validateForm('guest')
      }
      return this.errors
    },
  },
  beforeDestroy() {},
  mounted() {
    //this.$store.commit('SET_GUEST_INFO', {})
  },
}
</script>

<style lang="scss" scoped>
.default-form {
  .form-group {
    .custom-input {
      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: rgba(var(--color-black-source), 0.5);
        opacity: 0.5;
        font-weight: normal;
      }
    }
    .remember {
      padding-bottom: $px5;
      label {
        color: $color-primary;
        font-weight: 500;
        margin-bottom: 0;
      }
    }
  }
}
.error-class {
  color: red;
}
</style>
